import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, currencyMask } from '~/utils/masks';

export const HeaderInstallmentsExtra = [
  {
    id: 1,
    value: 'Nome do cliente',
    maxChar: 15,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 15,
  },
  {
    id: 3,
    value: 'Data aprovação do Cartão',
    maxChar: 20,
  },
  {
    id: 4,
    value: 'Operador(a) de Contratação',
    maxChar: 18,
  },
  {
    id: 5,
    value: 'Data Contratação',
    maxChar: 20,
  },
  {
    id: 6,
    value: 'Modalidade do Cartão',
    maxChar: 20,
  },
  {
    id: 7,
    value: 'UF Loja Contratação',
    maxChar: 20,
  },
  {
    id: 8,
    value: 'Valor Liberado',
    maxChar: 20,
  },
  {
    id: 9,
    value: 'Status',
    maxChar: 10,
  },
  {
    id: 10,
    value: 'Data primeira compra',
    maxChar: 20,
  },
  {
    id: 11,
    value: 'Loja de Contratação',
    maxChar: 20,
  },
];

export const BodyReportInstallmentsExtra = (data: any) => {
  const items = [];

  data?.forEach((i) => {
    const item: IListColumn[] = [
      {
        value: i.nome ? i.nome : '-',
        maxChar: 18,
      },
      {
        value: i.cpf ? cpfMask(i.cpf).masked : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.dataAprovacaoCartao
          ? moment(i.dataAprovacaoCartao, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '-',
        maxChar: 20,
        textAlign: 'center',
      },
      {
        value: i.operadorContratacao ? i.operadorContratacao : '-',
        maxChar: 18,
        textAlign: 'center',
      },
      {
        value: i.dataContratacao
          ? moment(i.dataContratacao, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '-',
        maxChar: 20,
        textAlign: 'center',
      },
      {
        value: i.modalidadeCartao ? i.modalidadeCartao : '-',
        maxChar: 20,
        textAlign: 'center',
      },
      {
        value: i.ufLojaContratacao ? i.ufLojaContratacao : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.valorLiberado ? currencyMask(i.valorLiberado) : '-',
        maxChar: 20,
        textAlign: 'center',
      },
      {
        value: i.status ? i.status : '-',
        maxChar: 10,
        textAlign: 'center',
      },
      {
        value: i.dataPrimeiraCompra
          ? moment(i.dataPrimeiraCompra, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '-',
        maxChar: 20,
        textAlign: 'center',
      },
      {
        value: i.lojaContratacao ? i.lojaContratacao : '-',
        maxChar: 20,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};
